import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Classes from '../common/Classes';
import FavouriteIcon from './FavouriteIcon';

const FavouriteIconComponent = ({
  dtmTag, id, handleClick, label, isFavourited, altSVG, classname, isDirectoryView
}) => {
  const attribute = { participationId: id };
  return (
    <div
      data-testid="Favourite-Icon-Component"
      data-dtm={dtmTag}
      data-dtm-attributes={JSON.stringify(attribute)}
      className={classname || classnames(Classes.favouriteParticipantIcon, Classes.primaryButton, Classes.borderRadius)}
      onClick={handleClick}
      role="button"
      tabIndex={0}
    >
      <span className={Classes.favouriteIconLabel}>
        <FavouriteIcon
          isFavourited={isFavourited}
          altSVG={altSVG}
        />
        {
          !isDirectoryView
            ? <span>{label}</span>
            : (
              <div className="directory-favourite-icon">
                <span className="mobile-view-icon" />
                <span className="desktop-view-icon">{label}</span>
              </div>
            )
        }
      </span>
    </div>
  );
};

FavouriteIconComponent.propTypes = {
  classname: PropTypes.string,
  dtmTag: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  isFavourited: PropTypes.bool.isRequired,
  altSVG: PropTypes.string.isRequired,
  isDirectoryView: PropTypes.bool
};

export default FavouriteIconComponent;
